// removed by extract-text-webpack-plugin
module.exports = {"background":"src-components-ModalSearch----ModalSearch-module---background---2laiD","close":"src-components-ModalSearch----ModalSearch-module---close---2DxgK","search-block":"src-components-ModalSearch----ModalSearch-module---search-block---2TbVq","search-result-wrapper":"src-components-ModalSearch----ModalSearch-module---search-result-wrapper---SMjP5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalSearch/ModalSearch.module.scss
// module id = 1188
// module chunks = 114276838955818